const { default: LoginRoute } = require("./Login/LoginRoute");

export default { LoginRoute }